var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDiscoveryOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#54d7ff;}.cls-2{opacity:.5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.04,46.29c-.41,0-.75-.34-.75-.75V14.46c0-.41,.34-.75,.75-.75s.75,.34,.75,.75v31.07c0,.41-.34,.75-.75,.75Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.04,19.12h28.34c.87,0,1.58,.71,1.58,1.58v4.81c0,1.1-.9,2-2,2H16.04v-8.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.04,32.5h16.76c1.1,0,2,.9,2,2v4.38c0,1.1-.9,2-2,2H16.04v-8.38h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDiscoveryOn);
export default __webpack_public_path__ + "static/media/menu_discovery_on.e95d38567e089e5dbff280132a725558.svg";
export { ForwardRef as ReactComponent };